import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const StackedEmailSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default StackedEmailSVG;
